export default class MfSelectModalController {
	/* @ngInject */
	/**
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/ktranslate').KTranslate} KTranslate
	 * @param {any[]} path
	 */
	constructor(
		$scope,
		$timeout,
		$uibModalInstance,
		KTranslate,
		path,
	) {
		this.path = path;
		this.tree = {};
		this.treeIndex = 0;

		let index = 0;
		const recTree = (/** @type {any[]} */ array, /** @type {any} */ tree) => {
			tree.index = index++;
			tree.item = array.shift();
			tree.child = array.length > 0 ? recTree(array, {}) : null;
			return tree;
		};

		this.tree = recTree([...path], {});

		this.$uibModalInstance = $uibModalInstance;
		(async () => {
			this.title = this.path.at(-1).name
				|| await KTranslate.request($scope, this.path.at(-1).kid);
			$timeout(() => $scope.$apply());
		})();
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		return this.$uibModalInstance.close(this.path);
	}
}
